import { defineMessages } from 'react-intl';

export default defineMessages({
  createBillerForm: {
    id: 'billerForm.createnew',
    defaultMessage: 'Create New Biller Form',
  },

  billerFormMandatory: {
    id: 'billerForm.mandatory',
    defaultMessage: 'Mandatory Field',
  },

  errorTransactionFee: {
    id: 'service.error.transactionFee.maxFee',
    defaultMessage: 'Maksimal Rp. 50.000',
  },
});
